import { SeoTabsCont } from "./homeSEO.styled";
import { IGroupsLinks } from "models/seoTrendingBlocks";
import { useEffect, useState } from "react";
import { classNames, labelHelper } from "helpers/themeHelpers";
import { gtmCPLink, gtmLocationBottomLink } from "GTMs/actions/homeActions";
import {ISendLoggingEventProps, sendLoggingEvent} from "../../../../../../../../libs/logging/helpers/sendLoggingEvent";
import {
  EnumActionNameLevel1,
  EnumActionNameLevel2,
  EnumActionNameLevel3, EnumGeneratedBy, EnumUxTypes, EnumWidgets
} from "../../../../../../../../libs/logging/types/loggingTypes";

interface ITabbedLinksProps {
  title: string;
  data: Array<IGroupsLinks>;
  className?: string;
  category?:string;
}

const TabbedLinks = (props: ITabbedLinksProps) => {
  const { data, title } = props;
  const [activeTab, setActiveTab] = useState<string>("");
  const tabs = data.map((tab) => {
    return { label: tab.block_title };
  });
  const selected_tab = data.filter((tab, index) => {
    return activeTab ? activeTab === tab.block_title : index === 0 && tab.block_title;
  });
  const content = selected_tab[0] && selected_tab[0].groups;
  const handleOnTabClick = (selected: string) => {
    const selectedTab = data.filter(
      (tab) => selected !== activeTab && selected == tab.block_title
    );
    if (selectedTab.length > 0) {
      setActiveTab(selectedTab[0].block_title);
    }
  };

  useEffect(() => {}, [activeTab]);
  const handleLogging =()=>{
    sendLoggingEvent({
      actionNameLvl1: EnumActionNameLevel1.SEARCH,
      actionNameLvl2: EnumActionNameLevel2.TAXONOMY,
      actionNameLvl3: EnumActionNameLevel3.CLICK,
      currentWidgetName: EnumWidgets.NA,
      ux_type: EnumUxTypes.BUTTON,
      generatedBy: EnumGeneratedBy.USER,
      listingData:{category : props?.category }

    } as ISendLoggingEventProps);
  }

  return (
    <SeoTabsCont className="contentVisibilityHidden p-16 mb-32 lightGrayBg radius-8">
      <h2 className="font-20">{title}</h2>
      <div className="seoTabs borderBottom mt-16">
        {tabs.map((data, index) => (
          <h3
            key={index}
            {...classNames(
              "relative inline me-32 pb-8 font-18 pointer darkGrayColor",
              activeTab === labelHelper(data) && "selected blackColor",
              !activeTab && index === 0 && "selected blackColor"
            )}
            onClick={() => handleOnTabClick(labelHelper(data))}
          >
            {labelHelper(data)}
          </h3>
        ))}
      </div>
      {selected_tab.length > 0 && (
        <ul className="flex mt-16">
          {(content || []).map((group, index) => (
            <li key={index} className="width-25">
              <h4 className="mb-16">
                {group.group_link ? (
                  <a
                    href={group.group_link}
                    onClick={handleLogging}
                    className="blackColor"
                  >
                    {group.group_title}
                  </a>
                ) : (
                  <div className="blackColor">{group.group_title}</div>
                )}
              </h4>
              <div className="font-14 flex flexDirectionColumn">
                {group.links?.map((data, index,array) => (
                    <a
                      href={data.link}
                      key={index} {...classNames("blackColor width-fit",index !== array.length - 1  && "mb-16")}
                      onClick={() => {
                        handleLogging();
                        data.is_cp ? gtmCPLink() : gtmLocationBottomLink()
                      }}
                    >
                      {data.title}
                    </a>
                ))}
              </div>
            </li>
          ))}
        </ul>
      )}
    </SeoTabsCont>
  );
};

export default TabbedLinks;
